import { render } from "./SuggestionsBar.vue?vue&type=template&id=f77592f0&scoped=true&lang=pug"
import script from "./SuggestionsBar.vue?vue&type=script&lang=js"
export * from "./SuggestionsBar.vue?vue&type=script&lang=js"

import "./SuggestionsBar.vue?vue&type=style&index=0&id=f77592f0&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f77592f0"]])

export default __exports__